import { DASHBOARD_API_ROUTES } from "./Dashboard.api.constant";
import ApiService from "@Src/services/ApiService";
import { store } from "@Src/app/store";
import { isInstituteStudent } from "@Src/utils/studentTypeUtils";


export const getDashboarddetails = async () => {
    return await ApiService.fetchData({
        url: DASHBOARD_API_ROUTES.DASHBOARD,
        method: 'get',
        params: ''
    })

}

export const getDashboardTestSeriesDetails = async (params?: any) => {
    return await ApiService.fetchData({
        url: DASHBOARD_API_ROUTES.DASHBOARD_TEST_SERIES,
        method: 'get',
        params: params

    })

}


export const getTestResult = async (params: any) => {
    return await ApiService.fetchData({
        url: DASHBOARD_API_ROUTES.TESTRESULT,
        method: 'get',
        params: params
    })
}


export const getUserTestReview = async (params: any) => {
    return await ApiService.fetchData({
        url: DASHBOARD_API_ROUTES.TESTREVIEW,
        method: 'get',
        params: params
    })
}

export const getLeaderBoard = async (params: any) => {
    return await ApiService.fetchData({
        url: DASHBOARD_API_ROUTES.LEADERBOARD,
        method: 'get',
        params: params
    })
}

export const getTestSeriesResult = async (params: any) => {
    return await ApiService.fetchData({
        url: DASHBOARD_API_ROUTES.TEST_SERIES_RESULT,
        method: 'get',
        params: params
    })
}


export const getUserTestSeriesReview = async (params: any) => {
    return await ApiService.fetchData({
        url: DASHBOARD_API_ROUTES.TEST_SERIES_REVIEW,
        method: 'get',
        params: params
    })
}

export const getLeaderBoardTestSeries = async (params: any) => {
    return await ApiService.fetchData({
        url: DASHBOARD_API_ROUTES.LEADERBOARD_TEST_SERIES,
        method: 'get',
        params: params
    })
}

export const getPopularTests = async (params: any) => {

    const state = store.getState();
    const loginData = state.login;
    
    // Add InstituteId parameter if user is an institute student
    if (isInstituteStudent(loginData)) {
        params.instituteId = loginData.InstituteId;
    }
    return await ApiService.fetchData({
        url: DASHBOARD_API_ROUTES.POPULAR_TEST,
        method: 'get',
        params: params
    })
}

export const getadviceoryTestSeries = async (data: any) => {

    const state = store.getState();
    const loginData = state.login;

    // Add InstituteId parameter if user is an institute student
    if (isInstituteStudent(loginData)) {
        data.instituteId = loginData.InstituteId;
    }

    return await ApiService.fetchData({
        url: DASHBOARD_API_ROUTES.ADVICORY_TEST_SERIES,
        method: 'post',
        data: data
    })
}

export const getAvgDurations = async (params?: any) => {
    return await ApiService.fetchData({
        url: DASHBOARD_API_ROUTES.AVG_DURATIONS,
        method: 'get',
        params: params
    })
}

export const getExamDetails = async (data: any) => {
    return await ApiService.fetchData({
        url: DASHBOARD_API_ROUTES.EXAM_DETAILS,
        method: 'post',
        data: data
    })
}

export const getTestDetails = async (data: any) => {
    return await ApiService.fetchData({
        url: DASHBOARD_API_ROUTES.TEST_DETAILS,
        method: 'post',
        data: data
    })
}

export const getBalanceTests = async () => {
    return await ApiService.fetchData({
        url: DASHBOARD_API_ROUTES.BALANCE_TESTS,
        method: 'get',
    })
}

export const postFeedback = async (data: any) => {
    return await ApiService.fetchData({
        url: DASHBOARD_API_ROUTES.USER_FEEDBACK,
        method: 'post',
        data: data
    })
}
export const getFeedback = async (params?: any) => {
    return await ApiService.fetchData({
        url: DASHBOARD_API_ROUTES.GET_FEEDBACK,
        method: 'get',
        params: params
    })
}


export const getErrorListDropdown = async (params?: any) => {
    return await ApiService.fetchData({
        url: DASHBOARD_API_ROUTES.GET_ERROR_LIST_DROPDOWN,
        method: 'get',
        params: params
    })
}

export const submitReport = async (data: any) => {
    return await ApiService.fetchData({
        url: DASHBOARD_API_ROUTES.SUBMIT_REPORT,
        method: 'post',
        data: data
    })
}
